import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { scroller } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import down_arrow from "../../assets/images/down_arrow.webp";

const classNames = (...classes) => classes.filter(Boolean).join(" ");

const scrollConfig = { smooth: true, offset: -80, duration: 500 };

function SingleItem({ description, link }) {
    if (link.startsWith('/')) {
        return (
            <RouterLink
                to={link}
                className="text-base font-medium text-gray-900 hover:text-black link cursor-pointer"
            >
                {description}
            </RouterLink>
        );
    }

    return (
        <a
            href={`#${link}`}
            className="text-base font-medium text-gray-900 hover:text-black link cursor-pointer"
            onClick={(e) => {
                e.preventDefault();
                scroller.scrollTo(link, scrollConfig);
            }}
        >
            {description}
        </a>
    );
}

export default function MenuItem({ description, link, items }) {
    return (
        <>
            {items ? (
                <Popover className="relative">
                    {({ open }) => (
                        <>
                            <Popover.Button
                                aria-label={`Abrir menú de ${description}`}
                                className={classNames(
                                    open ? "text-black" : "text-gray-900",
                                    "group bg-transparent rounded-md inline-flex items-center text-base font-medium hover:text-black focus:outline-none"
                                )}
                            >
                                <span className="link">{description}</span>
                                <img
                                    className={classNames(
                                        open ? "text-gray-600" : "text-gray-400",
                                        "hidden sm:block ml-2 h-5 w-5 group-hover:text-gray-500"
                                    )}
                                    src={down_arrow}
                                    alt=""
                                    aria-hidden="true"
                                />
                            </Popover.Button>

                            <Transition
                                show={open}
                                as={Fragment}
                                unmount={false}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <Popover.Panel
                                    static
                                    className="absolute z-10 -ml-4 mt-3 transform px-2 max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                                >
                                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                                        <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                                            {items.map((item) => (
                                                <SingleItem key={item.description} description={item.description} link={item.link} />
                                            ))}
                                        </div>
                                    </div>
                                </Popover.Panel>
                            </Transition>
                        </>
                    )}
                </Popover>
            ) : (
                <SingleItem description={description} link={link} />
            )}
        </>
    );
}
